// extracted by mini-css-extract-plugin
export default {"Draft":"Draft-kEAo9","NotStarted":"NotStarted-qTPx1","Published":"Published-KgpR9","Completed":"Completed-iKY7p","status":"status-DpSAx"};